<template>
    <v-row no-gutters>
        <template>
          
                <div class="p-4" v-if="!isLoading">
                    <v-expansion-panels focusable >
                        <v-expansion-panel v-for="(item, index) in faqs" :key="index">
                            <v-expansion-panel-header>{{ index+1+'. '+item.key }}</v-expansion-panel-header>
                            <v-expansion-panel-content class="mt-2" >
                                <v-row class="pt-5" v-html="item.value">

                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-row v-if="role.includes(2) || role.includes(3)">
                        <v-col cols="12" md="12" class="mt-5">
                            <div class="d-flex justify-content-center" >
                            <v-btn color="primary" :to="{ name: 'manage-faq.index'}">Edit</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </div>

        </template>
    </v-row>
</template>
<script>
export default {
    data() {
        return {
            user: JSON.parse(localStorage.getItem("user")),
            isLoading: true,
            role: [],
            faqs: [
                {
                    key: `Pendaftaran KP`,
                    value: `<p>Untuk mengikuti KP, Anda harus melakukan pendaftaran terlebih dahulu. Pendaftaran KP dapat
                                Anda lakukan melalui menu Kerja Praktik atau dapat dilakukan disini. Setelah
                                melakukan pendaftaran, petugas akan melakukan verifikasi terhadap pendaftaran Anda. Jika
                                pendaftaran Anda telah diverifikasi/disetujui oleh petugas, Anda akan mendapatkan surat
                                permohonan/pengantar yang dapat Anda tujukan ke calon perusahaan tempat Anda KP. Jika perlu
                                perbaikan, silakan lakukan perbaikan, kemudian tunggu petugas memverifikasi kembali.</p>`
                },
                {
                    key: `Unggah surat balasan`,
                    value: `
                                <p>Masukkan surat permohonan KP ke calon perusahaan tempat Anda akan melaksanakan KP. Maka anda
                                akan mendapatkan surat balasan diterima/ditolak dari perusahaan, silakan unggah berkas
                                tersebut. Anda wajib mengunggah surat balasan <strong>diterima kerja praktik</strong> atau
                                <strong>ditolak kerja praktik</strong> oleh perusahaan.
                                Tunggu petugas untuk memverifikasi surat balasan dari perusahaan. Jika kerja praktik
                                diterima perusahaan dan petugas sudah memverifikasi surat balasan maka anda bisa melanjutkan
                                KP. Namun jika ditolak kerja praktik di perusahaan tersebut, maka anda harus <strong>mendaftar
                                ulang</strong>. Tunggu petugas memverifikasi surat ditolak kerja praktik dari perusahaan untuk
                                mendaftar ulang.</p>`
                },
                {
                    key: `Unggah Laporan selesai KP`,
                    value: ` <p>Untuk menyelesaikan KP, anda harus mengupload beberapa dokumen sebagai syarat untuk menyelesaikan KP.</p>`
                },
                {
                    key: `Unggah berita acara & Selesai KP`,
                    value: ` <p>Jika sudah mengupload laporan selesai KP, Unggah berita acara. kemudian dosen akan memeberikan nilai KP anda.</p>`
                }
            ]
        }
    }, created() {
        this.getData()
        this.role  = this.user.roles.map( ro => {
        return  ro.id;
        })
    },
    computed: {
    },
    watch: {
    },
    methods: {
        getData() {
            this.axios.get("/api/faqs/").then((res) => {
                res.data ? this.faqs = res.data : false;
            }).finally(() => this.isLoading = false);
        }
    }
}
</script>